export default "__VITE_ASSET__cIE2slx6__"